/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import DisplayedWordVo from './DisplayedWordVo';
import IseTextVo from './IseTextVo';
import RefWordVo from './RefWordVo';




  /**
   * The RefAndDisplayedTextVo model module.
   * @module drill/model/RefAndDisplayedTextVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>RefAndDisplayedTextVo</code>.
   * @alias module:drill/model/RefAndDisplayedTextVo
   * @class
   */
  var exports = function() {
    var _this = this;




  };

  /**
   * Constructs a <code>RefAndDisplayedTextVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/RefAndDisplayedTextVo} obj Optional instance to populate.
   * @return {module:drill/model/RefAndDisplayedTextVo} The populated <code>RefAndDisplayedTextVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'displayText')) {
        obj['displayText'] = ApiClient.convertToType(data['displayText'], [DisplayedWordVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'refText')) {
        obj['refText'] = ApiClient.convertToType(data['refText'], [RefWordVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'iseText')) {
        obj['iseText'] = IseTextVo.constructFromObject(data['iseText']);
      }
    }
    return obj;
  }

  /**
   * 显示颜色用文本
   * @member {Array.<module:drill/model/DisplayedWordVo>} displayText
   */
  exports.prototype['displayText'] = undefined;
  /**
   * 腾讯打分用文本
   * @member {Array.<module:drill/model/RefWordVo>} refText
   */
  exports.prototype['refText'] = undefined;
  /**
   * 用于讯飞打分的文本
   * @member {module:drill/model/IseTextVo} iseText
   */
  exports.prototype['iseText'] = undefined;



  export default exports;
;


